import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { MillOfferService } from '../services/mill-offer.service';

export const productFieldTranslationGuard: CanActivateFn = async () => {
	const router = inject(Router);
	const millOfferService = inject(MillOfferService);
	try {
		await firstValueFrom(millOfferService.loadProductFieldNames());
		return true;
	} catch (err) {
		console.error('unable to load configuration field names', err);
		return router.createUrlTree(['/']);
	}
};
